import React, { useMemo } from 'react';
import { Tag } from 'rsuite';

// The stored status and its label differ for the first two: 'draft' is an
// expense saved but never sent, and 'pending' is one that has been sent and is
// waiting on a decision. "Not submitted" and "Submitted" say which is which
// from the employee's side, where the question is whether they still have
// something to do. See server/sql/expense_draft_status_schema.sql.
export default function ExpenseStatusBadge({ status }) {
  const { color, label } = useMemo(() => {
    const value = String(status || '').toLowerCase();
    if (value === 'draft') return { color: 'orange', label: 'Not submitted' };
    if (value === 'pending') return { color: 'cyan', label: 'Submitted' };
    if (value === 'approved') return { color: 'green', label: 'Approved' };
    if (value === 'rejected') return { color: 'red', label: 'Rejected' };
    if (value === 'cancelled') return { color: 'orange', label: 'Cancelled' };
    return { color: 'gray', label: 'Unknown' };
  }, [status]);

  return <Tag color={color}>{label}</Tag>;
}
